import styled from 'styled-components';
import { MenuItem } from '@mui/material';
import {
  OPTION_ITEM_HEIGHT,
  OPTION_ITEM_HEIGHT_WITH_DESCRIPTION,
} from '../constants';

const MenuItemStyled = styled(MenuItem)<{
  $multiple?: boolean;
  $hasDescription?: boolean;
  selected?: boolean;
}>`
  min-height: 0;
  height: ${({ $hasDescription }) =>
    $hasDescription
      ? `${OPTION_ITEM_HEIGHT_WITH_DESCRIPTION}px`
      : `${OPTION_ITEM_HEIGHT}px`};
  padding: ${({ $multiple }) => ($multiple ? '8px' : '16px')};
  border-radius: 8px;

  .MuiTypography-root {
    font-size: 14px;
  }

  :hover {
    background: #f6f6fb;
  }

  &.Mui-selected {
    background: none;

    :hover {
      background: #f6f6fb;
    }
  }
`;

export default MenuItemStyled;
